import ChipLink from 'components/chip-link';
import React, { memo, useEffect, useState } from 'react';
import './pedigree-chart-node-label.scss';

/**
 * Node label for the pedigree tree. Displays whether the animal is a sire or dam
 * and the animal id.
 * @param props
 */
export const PedigreeChartNodeLabel: React.FC<any> = memo((props: any) => {
  const {
    db,
    subIndex,
    asbvIds,
    nodeData,
  } = props;

  const [href, setHref] = useState<string>('');

  /**
   * Sets the link href.
   */
  useEffect(() => {
    let h = `/animal/${nodeData.animalId}?db=${db}`;
    if (subIndex) {
      h += `&scenario=${subIndex}`;
    }

    if (asbvIds) {
      h += `&asbvs=${asbvIds}`;
    }
    setHref(h);
  }, [asbvIds, db, nodeData.animalId, subIndex]);

  // Function to format the node label.
  const formatLabel = (_nodeData: any) => {
    if (_nodeData.studId === 'Unavailable') {
      // The studID is not available, so just print studId
      return _nodeData.studId;
    }
    // Check that we have a valid animalId
    if (_nodeData.animalId) {
      const flockCode:String = _nodeData.animalId.substring(0, 6);
      const drop:String = _nodeData.animalId.substring(6, 10);
      const animalID:String = _nodeData.animalId.substring(10);
      const studName:String = _nodeData.studId.substring(0, _nodeData.studId.length - 7);

      return (
        <section>
          <div>{studName}</div>
          <div>{`${flockCode}-${drop}-${animalID}`}</div>
        </section>
      );
    }
    // If no animalId then just return the studId.
    return _nodeData.studId;
  };

  return (
    <div className="sg-pedigree-chart-node-label">
      <div className="label__pedigree">{nodeData.typeLabel}</div>
      <ChipLink
        href={href}
        target="_blank"
        rel="noopener"
        disabled={!nodeData.isLinked}
      >
        {formatLabel(nodeData)}
      </ChipLink>
    </div>
  );
});

(PedigreeChartNodeLabel as any).whyDidYouRender = true;
